module.exports = __webpack_public_path__ + "angular-locale_de.js";


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-i18n/angular-locale_de.js
// module id = 1318
// module chunks = 12